
// プラグインの呼び出し
// import "./libs/_plugin.js";

// モジュールの呼び出し
import sideNaviClass from "./module/sideNaviClass";
import toggleClass from "./module/toggleClass";
import scrollScopeClass from "./module/scrollScopeClass";
import datePickerClass from "./module/datePickerClass";
import gridClass from "./module/gridClass";
import variableSelectClass from "./module/variableSelectClass";
import clientInfoClass from "./module/clientInfoClass";
import toggleShowClass from "./module/toggleShowClass";
import showOnceClass from "./module/showOnceClass";
import uploadFileClass from "./module/uploadFileClass";
import modalClass from "./module/modalClass";
import wysiwygClass from "./module/wysiwygClass";
import switchChkStatusClass from "./module/switchChkStatusClass";
import scratchTableClass from "./module/scratchTableClass";
import selectTagClass from "./module/selectTagClass";
import switchTabClass from "./module/switchTabClass";
import copyToClipboardClass from "./module/copyToClipboardClass";
import checkTermClass from "./module/checkTermClass";
import frmClass from "./module/frmClass";
import insertTxtClass from "./module/insertTxtClass";
import insertHtmlClass from "./module/insertHtmlClass";
import switchDispAreaClass from "./module/switchDispAreaClass";
import sessionClass from "./module/sessionClass";
import blockDisableClass from "./module/blockDisableClass";
import truncateClass from "./module/truncateClass";
import articleClass from "./module/articleClass";
import seminarClass from "./module/seminarClass";
import pageTopClass from "./module/pageTop";
import anchorScrollClass from "./module/anchorScrollClass";
import switchShowClass from "./module/switchShowClass";
import descriptionListClass from "./module/descriptionListClass";
import tooltipClass from "./module/tooltipClass";

import dashboardReadRecordGridClass from "./module/dashboardReadRecordGridClass";
import dashboardEmailGridClass from "./module/dashboardEmailGridClass";

import "./module/UCM1-004-02.js";
import "./module/UCM1-005-02.js";
import "./module/UCM3-07-001_content.js";
import "./module/UCM3-07-002-undefined.js";
import "./module/UCM3-07-003_image.js"
import "./module/UCM3-07-003_tag.js"
import "./module/UCM5-002-05.js";
import "./module/UCM6-002-002_01.js";
import "./module/UCM6-002-002_02.js";
import "./module/UCM6-002-002_03.js";
import "./module/UCM6-002-002_04.js";
import "./module/UCM6-003-002_02.js";
import "./module/UCM7-001-02.js";

import "./module/2020-11-18-SBCr-Patch";

import lockClass from "./module/lockClass";

// モジュールの実行
$(function () {

  // object-fitのポリフィル
  objectFitImages();

  // グローバルに追加するモジュールは先にnewしてwindowオブジェクトに追加
  var gridClassObj = new gridClass(); // テーブル管理
  var datePickerClassObj = new datePickerClass(); // デイトピッカー
  var variableSelectClassObj = new variableSelectClass(); // 案件担当者セレクト管理
  var blockDisableObj = new blockDisableClass(); // ブロック全体のdisable切り替え
  var modalClassObj = new modalClass(); // モーダルの表示

  var dashboardReadRecordGridClassObj = new dashboardReadRecordGridClass(); // テーブル管理
  var dashboardEmailGridClassObj = new dashboardEmailGridClass();

  var uploadFileClassObj = new uploadFileClass(); // 表示（一回のみの）管理
  var sessionObj = new sessionClass(); // セッション情報関連処理

  // 名前空間を定義
  var APP = APP || {};
  // 名前空間にオブジェクト追加
  APP.Grid = gridClassObj;
  APP.DashboardReadRecordGrid = dashboardReadRecordGridClassObj;
  APP.DashboardEmailGrid = dashboardEmailGridClassObj;
  APP.DatePicker = datePickerClassObj;
  APP.VariableSelect = variableSelectClassObj;
  APP.BlockDisable = blockDisableObj;
  APP.modal = modalClassObj;

  APP.uploadFileClassObj = uploadFileClassObj; // 表示（一回のみの）管理
  APP.session = sessionObj;  // セッション情報関連処理

  // グローバルに名前空間を追加
  window.APP = APP;

  // 各モジュール
  var toggleClassObj = new toggleClass(); // トグル(アコーディオン)表示
  var sideNaviClassObj = new sideNaviClass(); // サイドナビ
  var scrollScopeClassObj = new scrollScopeClass(); // スクロール制御
  var clientInfoClassObj = new clientInfoClass(); // クライアント情報管理
  var toggleShowClassObj = new toggleShowClass(); // 表示/非表示管理
  var showOnceClassObj = new showOnceClass(); // 表示（一回のみの）管理
  var wysiwygClassObj = new wysiwygClass(); // wysiwyg
  var switchChkStatusObj = new switchChkStatusClass(); // wysiwyg
  var scratchTableObj = new scratchTableClass(); // スクラッチしたテーブル用
  var switchChkStatusObj = new switchChkStatusClass(); // チェックボックスのステータス変更
  var selectTagObj = new selectTagClass(); // タグ選択
  var switchTabObj = new switchTabClass(); // タブ切り替え
  var copyToClipboardObj = new copyToClipboardClass(); // クリップボードコピー
  var checkTermObj = new checkTermClass(); // 利用規約チェック
  var frmObj = new frmClass(); // フォーム関連
  var insertTxtObj = new insertTxtClass(); // サンプルテキストの追加
  var insertHtmlObj = new insertHtmlClass(); // サンプルHTMLの追加
  var switchDispAreaObj = new switchDispAreaClass(); // 表示切り替え
  var truncateObj = new truncateClass(); // 行の省略
  var articleObj = new articleClass(); // 記事作成・編集関連処理
  var seminarObj = new seminarClass(); // セミナー情報関連処理
  var pageTopObj = new pageTopClass(); // ページトップ
  var anchorScrollObj = new anchorScrollClass(); // アンカーリンクの処理
  var switchShowObj = new switchShowClass();
  var descriptionListClassObj = new descriptionListClass(); // 定義リストの処理
  var tooltipClassObj = new tooltipClass(); // ツールチップ表示
  var lockClassObj = new lockClass(); // 編集ロック

  window.APP.lockClassObj = lockClassObj; // コンストラクタでsortableを実行しているのでここで設定

  // グリッドが存在すれば実行
  // ウィンドウリサイズ時のw2uiプラグイン表示バグ修正
  var $grid = $('.js-grid');
  $(window).on('resize', function () {
    if ($grid.length) {
      $('.w2ui-grid-records').trigger('scroll');
    }
  });

  // type属性が指定されていないbuttonタグ押下によるデフォルトのsubmit処理を発火させない
  // submit処理を発火させる場合は明示的に対象のbuttonタグへtype="submit"指定する
  $(document).on('click', 'button', function (e) {
    var type = $(this).attr('type');
    if (type !== 'submit' && type !== 'button') {
      return false;
    }
  });
});

